/**
 * @author jakubbujakowski
 * @since 2020-4-27
 */

import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { useAuth } from "@hooks/useAuth";

import { fetchPricings } from "@app/redux/endOfTenancy/endOfTenancy.actions";
import {
  getServiceLocationId,
  getTasks,
  getVoucher,
  getWarranty,
  getSquareMeters,
  getShowOffer,
} from "@app/redux/endOfTenancy/endOfTenancy.selectors";

const EndOfTenancyPriceUpdater = React.memo((): null => {
  const { isUserLoggedIn } = useAuth();

  const dispatch = useDispatch();
  const serviceLocationId = useSelector(getServiceLocationId);
  const tasks = useSelector(getTasks);
  const warranty = useSelector(getWarranty);
  const squareMeters = useSelector(getSquareMeters);
  const voucherToken = useSelector(getVoucher);
  const showOffer = useSelector(getShowOffer);

  const strigifyTasks = JSON.stringify(tasks);

  React.useEffect(() => {
    if (!serviceLocationId || !showOffer) return;

    dispatch(fetchPricings({ abortEnabled: true }));
  }, [
    dispatch,
    serviceLocationId,
    strigifyTasks,
    warranty,
    squareMeters,
    voucherToken,
    showOffer,
    isUserLoggedIn,
  ]);

  return null;
});

EndOfTenancyPriceUpdater.displayName = "EndOfTenancyPriceUpdater";

export { EndOfTenancyPriceUpdater };
